// extracted by mini-css-extract-plugin
module.exports = {"vanlife-L":"L_vanlife-L__HUmlO"};